import { call, put, takeLatest } from 'redux-saga/effects';
import { FOOD_MENU_ACTION_TYPE } from './foodmenu-type';
import { FOOD_MENU_KEY } from './foodmenu-reducer';
import { FOODMENU_INLINE_ERROR, FOODMENU_REQUEST_ID_LIST, FOODMENU_TRANSLATION_KEY } from './foodmenu-constant';
import { foodMenuCreators } from './foodmenu-action';
import { FoodMenuService } from './foodmenu-service';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { generalCreators } from '../../../../redux/general/general-action';
import { generalSagas } from '../../../../redux/general/general-saga';
import { history } from '../../../../router';
import { httpCreators, HttpResponse, Tags } from 'rbh-merchant-core';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { noop } from 'lodash';

function* getFoodMenuHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.FOOD_MENU, resp.data.menus as []));
    yield put(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.IS_POS_ACTIONED, resp.data.isPOSActioned));
  } else {
    yield put(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.FOOD_MENU, undefined));
  }
}

function* postPatchMenuHandler(resp: HttpResponse, callbackParams: {
  onSuccessCallback: () => void,
  validateMenuSku: () => void, setFieldError: (fieldName: string, errorShow: string[]) => void,
  clearFieldTagIsDeleted: () => void
}) {
  if (resp.success) {
    yield call(callbackParams.onSuccessCallback);
  } else if (resp.statusCode === 1799 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === FOODMENU_TRANSLATION_KEY.MENU_NAME_TH_DUP) {
        yield call(callbackParams.setFieldError, 'menuName', [FOODMENU_INLINE_ERROR.MENU_NAME_DUP]);
      } else if (key === FOODMENU_TRANSLATION_KEY.MENU_NAME_EN_DUP) {
        yield call(callbackParams.setFieldError, 'menuNameEN', [FOODMENU_INLINE_ERROR.MENU_NAME_DUP]);
      }
    }
  } else if (resp.statusCode === 1899 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === FOODMENU_TRANSLATION_KEY.MENU_NAME_TH_INVALID) {
        yield call(callbackParams.setFieldError, 'menuName', [FOODMENU_INLINE_ERROR.MENU_NAME_TH_INVALID]);
      } else if (key === FOODMENU_TRANSLATION_KEY.MENU_NAME_EN_INVALID) {
        yield call(callbackParams.setFieldError, 'menuNameEN', [FOODMENU_INLINE_ERROR.MENU_NAME_EN_INVALID]);
      } else if (key === FOODMENU_TRANSLATION_KEY.MENU_DESC_TH_INVALID) {
        yield call(callbackParams.setFieldError, 'menuDescription', [FOODMENU_INLINE_ERROR.MENU_DESC_TH_INVALID]);
      } else if (key === FOODMENU_TRANSLATION_KEY.MENU_DESC_EN_INVALID) {
        yield call(callbackParams.setFieldError, 'menuDescriptionEN', [FOODMENU_INLINE_ERROR.MENU_DESC_EN_INVALID]);
      } else if (key === FOODMENU_TRANSLATION_KEY.MENU_SKU_ID_INVALID) {
        yield call(callbackParams.setFieldError, 'menuSKUId', [FOODMENU_INLINE_ERROR.MENU_SKU_ID_INVALID]);
      } else if (key === FOODMENU_TRANSLATION_KEY.MENU_SKU_ID_REQUIRED) {
        yield call(callbackParams.validateMenuSku);
      } else if (key === FOODMENU_TRANSLATION_KEY.MENU_CATEGORY_NOT_FOUND) {
        yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
          visible: true,
          modalTitle: 'main.foodmenu.addmenu.form.error.notFoundCategory.title',
          modalContent: 'main.foodmenu.addmenu.form.error.notFoundCategory.content',
          onOk: noop,
          type: MODAL_TYPE.ERROR
        }));
      }
      else if (key === FOODMENU_TRANSLATION_KEY.MENU_TAGS_NOT_FOUND) {
        yield call(callbackParams.clearFieldTagIsDeleted);
        yield call(callGetMenuTags, noop);
      }
    }
  } else if (resp.statusCode === 1899) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        history.push('/main/foodmenu');
      },
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* deleteFoodMenuHandler(resp: HttpResponse, callbackParams: { resetReload: () => void }) {
  if (resp.success) {
    yield call(callbackParams.resetReload);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* callFoodMenu() {
  yield put(httpCreators.request({
    id: FOODMENU_REQUEST_ID_LIST.GET_FOOD_MENU,
    sagaHandler: getFoodMenuHandler as any,
    service: FoodMenuService.getFoodMenus
  }));
  yield call(generalSagas.callTnc);
}

function* callGetMenuTags(onFailureCallback: () => void, onSuccessCallback?: (tagMaster: Tags[]) => void) {
  yield put(httpCreators.request({
    id: FOODMENU_REQUEST_ID_LIST.GET_TAG_MENU,
    sagaHandler: getMenuTagsHandler,
    service: FoodMenuService.getMenuTags,
    callbackParams: { onFailureCallback, onSuccessCallback }
  }));
}

function* getMenuTagsHandler(resp: HttpResponse, callbackParams: { onFailureCallback: () => void, onSuccessCallback?: (tagMaster: Tags[]) => void }) {
  if (resp.success) {
    yield put(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.TAGS_LIST, resp.data.tags));
    if (callbackParams?.onSuccessCallback) {
      yield call(callbackParams.onSuccessCallback, resp.data.tags);
    }
  } else {
    yield put(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.TAGS_LIST, undefined));
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: callbackParams?.onFailureCallback,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getFoodQcKeywordHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.FOOD_QC_KEYWORD, resp.data.map((each: any) => {
      return each.keywordName as string;
    })));
  } else {
    yield put(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.FOOD_QC_KEYWORD, []));
  }
}

export const foodMenuSagas = {
  callFoodMenu,
  getFoodMenuHandler,
  postPatchMenuHandler,
  deleteFoodMenuHandler,
  callGetMenuTags,
  getMenuTagsHandler,
  getFoodQcKeywordHandler,
  watchers: [
    takeLatest(FOOD_MENU_ACTION_TYPE.CALL_FOOD_MENU, callFoodMenu)
  ]
};
